module.exports = __webpack_public_path__ + "static/media/pk_audio.936fe7d9.jpg";